import { Link } from 'react-router-dom';
import clsx from 'clsx';

import { SidebarItemProps } from './types';

const SidebarItem = (props: SidebarItemProps) => {
  const { isCurrentRoute, item, path, isSidebarOpen } = props;

  const { id, Icon, label, route } = item;

  const itemBackground = isCurrentRoute ? 'bg-primary6' : '';
  const itemColor = isCurrentRoute ? 'text-theme' : 'text-grey';

  return (
    <Link
      key={id}
      to={path || route}
      className={clsx(
        'flex items-center rounded-lg py-3',
        itemBackground,
        isSidebarOpen ? 'mx-4 gap-3 pl-2' : 'mx-2 justify-center'
      )}
    >
      <div>
        <Icon className={clsx('size-6', itemColor)} />
      </div>
      {isSidebarOpen && (
        <span
          className={`truncate text-center text-base font-semibold ${itemColor}
      `}
        >
          {label}
        </span>
      )}
    </Link>
  );
};

export default SidebarItem;
